import type { AuthRepositoryInterface } from '../../domain/interfaces/AuthRepositoryInterface';
import type { ResetPasswordData } from '@/types';

export class ResetPasswordUseCase {
  constructor(private readonly authRepository: AuthRepositoryInterface) {}

  async execute(data: ResetPasswordData): Promise<{ message: string }> {
    return this.authRepository.resetPassword(data);
  }
}
